import { FIELD_SIZE } from '../../constants/field';
export const checkBigIntInField = (bigNum) => {
    return bigNum < FIELD_SIZE;
};
//# sourceMappingURL=crypto.js.map